import { ReactElement } from 'react';
import { FatLabelStyled } from './styles';
import { ShoppingCardIcon, TileUserIcon } from '@root/src/assets/images';
import TimerTag from '../../timerTag';
import styled from 'styled-components';
import { ResultOptionType } from '../../order/types';
import ResultLable from './getResultIcon';

type StatusLabelI = {
  status: string;
  timerEnd: number;
  result: ResultOptionType;
};

const LeftMarginContainer = styled.div`
  margin-left: 32px;
`;

const StatusLabel = ({
  status,
  timerEnd,
  result,
}: StatusLabelI): ReactElement => {
  const dataTestId = 'healthcheck-order-status-label';

  switch (status) {
    case 'pending':
      return (
        <LeftMarginContainer data-testid={dataTestId}>
          <TimerTag withLabel timerEnd={timerEnd} />
        </LeftMarginContainer>
      );
    case 'done':
      return <ResultLable result={result} dataTestId={dataTestId} />;
    case 'confirmed':
      return (
        <FatLabelStyled data-testid={dataTestId}>
          <TileUserIcon />
          {status && status[0].toUpperCase() + status.slice(1)}
        </FatLabelStyled>
      );
    case 'ordered':
    default:
      return (
        <FatLabelStyled data-testid={dataTestId}>
          <ShoppingCardIcon />
          {status && status[0].toUpperCase() + status.slice(1)}
        </FatLabelStyled>
      );
  }
};

export default StatusLabel;
